<template>
  <div>
    <b-modal  @hide="hide" id="editModal" size="xl" title="Site Düzenle" @show="detail" hide-footer>
      <b-form @submit="onSubmit" >

        <div class="row">
          <div class="col-md-6">
            <b-form-group label="Site Adı">
              <b-input v-model="site_name" required></b-input>
            </b-form-group>
          </div>
            <div class="col-md-6">
                <b-form-group label="Bakiye">
                    <b-input v-model="balance" required></b-input>
                </b-form-group>
            </div>
            <div class="col-md-6">
                <b-form-group label="Para Yatırma Komisyonu">
                    <b-input v-model="deposit_commission" required></b-input>
                </b-form-group>
            </div>
            <div class="col-md-6">
                <b-form-group label="Para Çekme Komisyonu">
                    <b-input v-model="withdrawal_commission" required></b-input>
                </b-form-group>
            </div>
            <div class="col-md-6">
            <b-form-group
                label="API SERVİSİ"
                v-slot="{ ariaDescribedby }"
            >
              <b-form-checkbox switch size="" v-model="api">
                <div v-if="api">Açık</div>
                <div v-else>Kapalı</div>
              </b-form-checkbox>
            </b-form-group>
          </div>
          <div class="col-md-6" v-if="api">
            <b-form-group label="Sağlayıcının bildirdiği Callback URL">
              <b-input v-model="notification_url" required></b-input>
            </b-form-group>
          </div>
          <div class="col-md-12"  v-if="api">
            <b-form-group label="SID">
              <b-button-group>
                <b-button @click="newSecret" class="btn-sm" v-b-tooltip:v-b-hover title="Yeni Sid & Key Üret"> <i class="fas fa-sync"></i> </b-button>
              </b-button-group>
              <b-input v-model="sid" disabled></b-input>
            </b-form-group>
          </div>
          <div class="col-md-12"  v-if="api">
            <b-form-group label="KEY">
              <b-input v-model="key" disabled></b-input>
            </b-form-group>
          </div>
          <div class="col-md-6">
            <b-form-group
                label="Yatırım Sonrası Yönlendirme"
                v-slot="{ ariaDescribedby }"
            >
              <b-form-checkbox switch size="" v-model="redirect">
                <div v-if="redirect">Açık</div>
                <div v-else>Kapalı</div>
              </b-form-checkbox>
            </b-form-group>
          </div>
          <div class="col-md-6" v-if="redirect">
            <b-form-group
                label="Yönlendirme Adresi"
            >
              <b-input v-model="redirect_url"></b-input>
            </b-form-group>
          </div>

        </div>
        <hr>
        <div class="row">

        </div>
        <div class="d-flex justify-content-center" v-if="!loading">
          <b-button type="submit" variant="success" class=""> <i class="fas fa-check" /> Kaydet</b-button>
        </div>
        <div class="d-flex justify-content-center" v-if="loading">
          <b-button type="submit" variant="success" class="" disabled> <span>  <i class="fas fa-spinner fa-spin"></i></span> </b-button>
        </div>
      </b-form>




    </b-modal>
  </div>
</template>

<script>
import sitesService from "@/services/sitesService";

export default {
  name: "CreateGroup",
  data() {
    return {
      loading: false,
      site_name: '',
      sid: '',
      key: '',
      api: false,
      notification_url: '',
      redirect: false,
      redirect_url: '',
      deposit_commission: 0,
      withdrawal_commission: 0,
        balance: 0,
    }
  },
  props: ['id'],
  methods: {
    hide() {
      this.api = false
      this.notification_url = ''
      this.site_name = ''
      this.sid = ''
      this.key = ''
    },
    onSubmit(event) {
      event.preventDefault()
      this.loading = true
      sitesService.edit ({
        site_name: this.site_name,
        sid: this.sid,
        key: this.key,
        notification_url: this.notification_url,
        api: this.api,
        id: this.id,
        redirect: this.redirect,
        redirect_url: this.redirect_url,
          deposit_commission: this.deposit_commission,
          withdrawal_commission: this.withdrawal_commission,
          balance: this.balance

      })
          .then((res) => {
            this.loading = false
            if(res.state){
              this.$store.dispatch('getNotifyMessage', {siteConfirm: true, show: true, icon: 'success', title: 'Başarıyla Düzenlendi.', message: ''})
              this.$bvModal.hide('editModal')
              this.$store.dispatch('getRefresh', true)
            }else{
              this.$store.dispatch('getConfirmMessage', {show: true, icon: 'error', title: 'Ops!', message: res.message})
            }
          })
    },
    copy(item){
      let input = document.createElement('textarea');
      input.innerHTML = item;
      document.body.appendChild(input);
      input.select();
      let result = document.execCommand('copy');
      document.body.removeChild(input);
      this.$store.dispatch('getNotifyMessage', {show:true, icon: 'success', title: 'Kopyalandı', message: item})
      return result
    },
    newSecret() {
      this.loading = true
      sitesService.changeSecrets ({
        id: this.id
      })
          .then((res) => {
            this.loading = false
            if(res.state){
              this.$store.dispatch('getNotifyMessage', {show: true, icon: 'success', title: 'Başarıyla Düzenlendi.', message: ''})
              this.$bvModal.hide('editModal')
              this.$store.dispatch('getRefresh', true)
            }else{
              this.$store.dispatch('getConfirmMessage', {show: true, icon: 'error', title: 'Ops!', message: res.message})
            }
          })
    },
    detail(){
      this.loading = true
      sitesService.detail({id: this.id})
      .then((res) => {
        this.loading = false
        if(res.state){
          this.site_name = res.data.site_name
          this.key = res.data.key
          this.api = res.data.api
          this.notification_url = res.data.notification_url
          this.sid = res.data.sid
          this.redirect = res.data.redirect
          this.redirect_url = res.data.redirect_url
            this.deposit_commission = res.data.deposit_commission
            this.withdrawal_commission = res.data.withdrawal_commission
            this.balance = res.data.balance
        }else {
          this.$store.dispatch('getConfirmMessage', {show: true, icon: 'error', title: 'Ops!', message: res.message})
        }
      })
    }
  }
}
</script>

<style scoped>

</style>